import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 预警信息
 */
export class EarlyWarningControllerSvr {
    constructor() {
        this.baseurl = 'EarlyWarningControllerSvr.assx/';
    }

    /**
     * 处理然后关闭预警
     * token:String, warningCode:String, disposeText:String
     */
    DealAndStopEarlyWarning(token, warningCode, disposeText) {
        return request.post(this.baseurl + 'DealAndStopEarlyWarning', Qs.stringify({
            token: token,
            warningCode: warningCode,
            disposeText: disposeText
        }));
    }

    /**
     * 获取预警处理日志列表
     * token:String, warningCode:String
     */
    GetWarningDisposelogByWarningCode(token, warningCode) {
        return request.post(this.baseurl + 'GetWarningDisposelogByWarningCode', Qs.stringify({
            token: token,
            warningCode: warningCode
        }));
    }

    /**
     * 获取预警列表
     * token:String, key:String, isDispose:int, startIndex:int, maxSize:int
     */
    GetEarlyWarningList(token, key, isDispose, startIndex, maxSize) {
        return request.post(this.baseurl + 'GetEarlyWarningList', Qs.stringify({
            token: token,
            key: key,
            isDispose: isDispose,
            startIndex: startIndex,
            maxSize: maxSize
        }));
    }

    /**
     * 获取预警详情
     * token:String, warningCode:String
     */
    GetEarlyWarning(token, warningCode) {
        return request.post(this.baseurl + 'GetEarlyWarning', Qs.stringify({
            token: token,
            warningCode: warningCode
        }));
    }
}